import React from 'react'
import Button, { TYPES } from '../Button/index'
import { H2, H4, HEADING_TYPES } from '../Heading/index'
import Link from '../Link/index'
import { TARGET_BLANK } from '../Link/constants'
import Loading, { LOADING_ICON_BLUE_DARK_BG_WHITE } from '../Loading/index'
import { getEmailCustomerServiceUrl } from '../../services/url/index'
import { URL_ACCOUNT } from '../../services/url/constants'

function CustomerServiceBody ({
  before, link, after, userLanguage,
}) {
  return (
    <div className="modal-end-trial__body">
      {before}
      <Link
        className="modal-end-trial__link"
        to={getEmailCustomerServiceUrl(userLanguage)}
        directLink
        target={TARGET_BLANK}
      >
        {link}
      </Link>
      {after}
    </div>
  )
}

export function ModalEndTrial ({
  view,
  staticText,
  userLanguage,
  onConfirm,
  onCancel,
}) {
  if (view === 'paymentError') {
    return (
      <div className="modal-end-trial">
        <H4 className="modal-end-trial__heading modal-end-trial__heading--error">
          {staticText.get('paymentErrorHeading')}
        </H4>
        <CustomerServiceBody
          before={staticText.get('paymentErrorBodyBefore')}
          link={staticText.get('paymentErrorBodyLink')}
          after={staticText.get('paymentErrorBodyAfter')}
          userLanguage={userLanguage}
        />
        <div className="modal-end-trial__buttons">
          <Button
            className="modal-end-trial__cta button--stacked"
            type={TYPES.PRIMARY}
            url={`${URL_ACCOUNT}#payment-info`}
            onClick={onCancel}
          >
            {staticText.get('updatePaymentMethod')}
          </Button>
        </div>
      </div>
    )
  }

  if (view === 'genericError') {
    return (
      <div className="modal-end-trial">
        <H4 className="modal-end-trial__heading modal-end-trial__heading--error">
          {staticText.get('genericErrorHeading')}
        </H4>
        <CustomerServiceBody
          before={staticText.get('genericErrorBodyBefore')}
          link={staticText.get('genericErrorBodyLink')}
          after={staticText.get('genericErrorBodyAfter')}
          userLanguage={userLanguage}
        />
        <div className="modal-end-trial__buttons">
          <Button
            className="modal-end-trial__cancel button--stacked"
            type={TYPES.SECONDARY}
            onClick={onCancel}
          >
            {staticText.get('endTrialConfirmationCancelButtonText')}
          </Button>
          <Button
            className="modal-end-trial__continue button--stacked"
            type={TYPES.PRIMARY}
            onClick={onConfirm}
          >
            {staticText.get('retry')}
          </Button>
        </div>
      </div>
    )
  }

  if (view === 'processing') {
    return (
      <div className="modal-end-trial">
        <H2 as={HEADING_TYPES.H6}>{staticText.get('endTrialConfirmationMessage')}</H2>
        <div className="modal-end-trial__processing">
          <Loading visible icon={LOADING_ICON_BLUE_DARK_BG_WHITE} />
        </div>
      </div>
    )
  }

  return (
    <div className="modal-end-trial">
      <H2 as={HEADING_TYPES.H6}>{staticText.get('endTrialConfirmationMessage')}</H2>
      <div className="modal-end-trial__buttons">
        <Button
          className="modal-end-trial__cancel button--stacked"
          type={TYPES.SECONDARY}
          onClick={onCancel}
        >
          {staticText.get('endTrialConfirmationCancelButtonText')}
        </Button>
        <Button
          className="modal-end-trial__continue button--stacked"
          type={TYPES.PRIMARY}
          onClick={onConfirm}
        >
          {staticText.get('endTrialConfirmationButtonText')}
        </Button>
      </div>
    </div>
  )
}

export default ModalEndTrial
